'use client';

import { useState } from 'react';
import { cn } from '@skin-seoul/design-system';
import { ReviewVideoPlayer } from './ReviewVideoPlayer';
import { ReviewVideoThumbnail } from './ReviewVideoThumbnail';

interface ReviewVideoInlineProps {
  url: string;
  playMarkSize: number;
  className?: string;
}

/**
 * A clip that plays in the slot it already occupies.
 *
 * The tiles around it open the full-screen photo viewer, which is the wrong home for a clip: it
 * takes over the page for something being watched alongside the review it belongs to. Both states
 * stop the click short of that tile, so reaching for the controls does not open the viewer instead.
 */
export const ReviewVideoInline = ({
  url,
  playMarkSize,
  className = 'w-full h-full object-cover',
}: ReviewVideoInlineProps) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const startPlaying = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsPlaying(true);
  };

  return isPlaying ? (
    // The whole frame, letterboxed, rather than the crop a still can afford.
    <ReviewVideoPlayer
      url={url}
      className={cn(className, 'object-contain bg-generic-100')}
      onClick={(event) => event.stopPropagation()}
    />
  ) : (
    <ReviewVideoThumbnail url={url} playMarkSize={playMarkSize} className={className} onClick={startPlaying} />
  );
};

export default ReviewVideoInline;
